// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"447":"6a706d0f2eac10cb","478":"e85ea446b8f5913b"}[chunkId] + ".css";
};